import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6ecba878")

_pushScopeId("data-v-6ecba878")
const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "el-icon-edit" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("基础信息")
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "el-icon-headset" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("文案编辑")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_el_menu = _resolveComponent("el-menu")
  const _component_el_aside = _resolveComponent("el-aside")
  const _component_router_view = _resolveComponent("router-view")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_aside, { width: "240px" }, {
        default: _withId(() => [
          _createVNode(_component_el_menu, {
            "default-active": _ctx.$route.name,
            class: "el-menu-vertical-demo",
            router: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_el_menu_item, {
                index: "WordsBasic",
                route: {name: 'WordsBasic', params: _ctx.$route.params}
              }, {
                title: _withId(() => [
                  _hoisted_2
                ]),
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }, 8, ["route"]),
              _createVNode(_component_el_menu_item, {
                index: "WordsDetailEditor",
                route: {name: 'WordsDetailEditor', params: _ctx.$route.params}
              }, {
                title: _withId(() => [
                  _hoisted_4
                ]),
                default: _withId(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["route"])
            ]),
            _: 1
          }, 8, ["default-active"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_main, { class: "main" }, {
        default: _withId(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})